class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute('data-id');
    this.page = this.getAttribute('data-page');
    this.url = this.querySelector('a').getAttribute('href');

    if (this.id && this.page && this.url) {
      this.addEventListener('click', () => {
        this.setHistory(this.id, this.page, this.url);
      });
    }
  }

  setHistory(id, page, url) {
    let stateData = history.state || {};
    stateData.collection_item_id = id;
    if (page) {
      history.replaceState(stateData, '', this.getUrlForPage(page));
    } else {
      history.replaceState(stateData, '');
    }
    history.scrollRestoration = 'auto';
    window.location.href = url;
  }

  getUrlForPage(page) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (page == 1) {
      params.delete('page');
    } else {
      params.set('page', page);
    }

    url.search = params.toString();

    return url.toString();
  }
}

customElements.define('product-card', ProductCard);
